/* eslint-disable */
//styles
import "../../src/styles/App.css";
import Logo from "../styles/img/header.svg";

//react
import { useEffect, useState } from "react";

//redux
import { scanToken } from "../lib/slices/paladin";
import { store } from "../lib/store";

//hooks
import RoundLoader from "../Hooks/RoudLoader";

//libs
import { datadogLogs } from "@datadog/browser-logs";
import { MdCancel } from "react-icons/md";

//Components
import InvitationFail from "../Components/InvitationFail";
import AcuantCamaraResult from "../Components/AcuantCamaraResult";

//Utils
import { isVerifiedMobileDevice } from "../Utils/deviceValidation";
import CameraGate from "../Components/Common/CameraGate";

const AuthAcuant = () => {
    const [loading, setLoading] = useState(false);
    const { dispatch } = store;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get("token");
    const [tenantColor, setTenantColor] = useState(localStorage.getItem(`tenantColor_${token}`) || "#6A2ABD");
    const [tenantImage, setTenantImage] = useState(Logo);
    const [tenantName, setTenantName] = useState("");
    const [responseScan, setResponseScan] = useState(null);

    const queryData = async () => {
        setLoading(true);
        var data = { token };

        try {
            const response = await dispatch(scanToken({ data }));
            const resolvedColor = response?.payload?.ScanToken?.custom_color || "#6A2ABD";
            setTenantColor(resolvedColor);
            localStorage.setItem(`tenantColor_${token}`, resolvedColor);
            setTenantImage(
                response?.payload?.ScanToken?.custom_image &&
                `data:image/jpeg;base64,${response?.payload?.ScanToken?.custom_image}`
            );
            setTenantName(
                response?.payload?.ScanToken?.account_name
                    ? response?.payload?.ScanToken?.account_name
                    : ""
            );
            setResponseScan(response?.payload?.ScanToken);
            datadogLogs.logger.log(
                `Token validated (App) with invitation ${response?.payload?.ScanToken?.invitation_id}`,
                {
                    category: "token-validation",
                    status: "info",
                    tenantName: response?.payload?.ScanToken?.account_name,
                    invitationId: response?.payload?.ScanToken?.invitation_id,
                    token: token,
                }
            );
        } catch (error) {
            datadogLogs.logger.log("Error validating token (App) - additional data", {
                category: "error",
                status: "info",
                token: token,
                errorMessage: error?.message,
            });
        } finally {
            setLoading(false);
        }
    };

    const initialize = () => {
        try {
            let callback = {
                onSuccess: function () {
                    window.AcuantJavascriptWebSdk.start(
                        () => { },
                        false, //set to true if you want to run one worker at a time. Default to false.
                        0 //set to 1 if hosting via cdn, defaults to 0
                    );
                },
                onFail: function (code, description) {
                    datadogLogs.logger.error("Error initializing worker", {
                        category: "worker-initialization",
                        status: "error",
                        errorCode: code,
                        errorDescription: description,
                        token: token,
                    });
                },
            };

            let base64Token = btoa(
                process.env.REACT_APP_USER_NAME + ":" + process.env.REACT_APP_PASSWORD
            );
            window.AcuantJavascriptWebSdk.initialize(
                base64Token, //Acuant credentials in base64 (basic auth format id:pass)
                process.env.REACT_APP_ACUANT_ACAS_ENDPOINT, //endpoint for Acuant's ACAS server
                callback, //callback shown below
                0 //set to 1 if hosting via cdn, defaults to 0
            );
        } catch (error) {
            datadogLogs.logger.error("Exception initializing Acuant SDK", {
                category: "worker-initialization",
                status: "error",
                errorMessage: error,
                token: token,
            });
        }
    };

    useEffect(() => {
        initialize();
        queryData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {loading ? (
                <section className="flex justify-center items-center min-h-screen flex-col gap-3 container px-3 py-5 bg-[#F8F7F6] w-full">
                    <RoundLoader
                        loading={loading}
                        color={tenantColor}
                        responseScan={responseScan}
                        tenantImage={tenantImage}
                        tenantName={tenantName}
                    />
                </section>
            ) : (
                <>
                    {responseScan?.invitation_id && (
                        <>
                            {isVerifiedMobileDevice() ? (
                                <CameraGate tenantColor={tenantColor} responseScan={responseScan}>
                                    <>
                                        {!loading && (
                                            <>
                                                {
                                                    <section className="flex justify-start items-center flex-col gap-3 container px-3 py-1 bg-[#F8F7F6] w-full">
                                                        <AcuantCamaraResult
                                                            responseScan={responseScan}
                                                            tenantColor={tenantColor}
                                                            tenantImage={tenantImage}
                                                            tenantName={tenantName}
                                                        />
                                                    </section>
                                                }
                                            </>
                                        )}
                                    </>
                                </CameraGate>
                            ) : (
                                <div className="flex justify-center items-center min-h-screen flex-col gap-3 container px-3 py-5 bg-[#F8F7F6] w-full">
                                    <MdCancel size={150} className="text-[#E43122]" />
                                    <h2 className="text-2xl text-[#E43122]">Error</h2>
                                    <p className="my-5 text-center text-sm">
                                        PALIDIN WebID is not available for desktop computers.{" "}
                                        <br></br>
                                        Please open the authentication invitation on a mobile
                                        device.
                                    </p>
                                </div>
                            )}
                        </>
                    )}
                </>
            )}

            {(responseScan?.error ||
                token === null ||
                responseScan === undefined) && <InvitationFail />}
        </>
    );
};

export default AuthAcuant;
